import { ComponentType } from "react";
import {
  GraphUp,
  InboxFill,
  CaretRightFill,
  Gear,
  GridFill,
  HouseFill,
  PlayCircleFill,
  BookFill,
} from "react-bootstrap-icons"; // TODO: Replace with antd icons and remove React-Boostrap when portal is no longer using it.
import {
  UserOutlined,
  TeamOutlined,
  ContactsOutlined,
  CloseSquareOutlined,
  ArrowRightOutlined,
  BankOutlined,
  EllipsisOutlined,
  BranchesOutlined,
  AuditOutlined,
  ToolFilled,
  MailFilled,
  SearchOutlined,
  NodeIndexOutlined,
  SwapOutlined,
  FileProtectOutlined,
  LockOutlined,
  SafetyOutlined,
  DollarOutlined,
  BgColorsOutlined,
  GlobalOutlined,
  SnippetsOutlined,
  MailOutlined,
  RobotOutlined,
  ApiOutlined,
  DeploymentUnitOutlined,
  AlertOutlined,
} from "@ant-design/icons";

type IconProps = {
  name?: string;
  library?: "react-bootstrap";
  className?: string;
};

type IconComponent = ComponentType<{ className?: string }>;

// Do not use React-Bootstrap-Icons for any new values.
const iconMap: Record<string, IconComponent> = {
  settings: Gear,
  analytics: GraphUp,
  applications: InboxFill,
  home: HouseFill,
  video: PlayCircleFill,
  book: BookFill,
  toolFilled: ToolFilled,
  userOutlined: UserOutlined,
  teamOutlined: TeamOutlined,
  contactsOutlined: ContactsOutlined,
  closeSquareOutlined: CloseSquareOutlined,
  arrowRightOutlined: ArrowRightOutlined,
  bankOutlined: BankOutlined,
  ellipsisOutlined: EllipsisOutlined,
  branchesOutlined: BranchesOutlined,
  auditOutlined: AuditOutlined,
  searchOutlined: SearchOutlined,
  nodeIndexOutlined: NodeIndexOutlined,
  swapOutlined: SwapOutlined,
  fileProtectOutlined: FileProtectOutlined,
  lockOutlined: LockOutlined,
  safetyOutlined: SafetyOutlined,
  dollarOutlined: DollarOutlined,
  bgColorsOutlined: BgColorsOutlined,
  globalOutlined: GlobalOutlined,
  snippetsOutlined: SnippetsOutlined,
  agenticAI: GridFill,
  mail: MailFilled,
  mailOutlined: MailOutlined,
  robotOutlined: RobotOutlined,
  apiOutlined: ApiOutlined,
  deploymentUnitOutlined: DeploymentUnitOutlined,
  alertOutlined: AlertOutlined,
};

const Icon = ({ name, className }: IconProps) => {
  if (name === undefined || name === null) {
    return null;
  }
  const Component = iconMap[name];
  if (Component) {
    return <Component className={className} />;
  }
  return <CaretRightFill className={className} />;
};

export default Icon;
